import { CloudRain, Shirt, Footprints, Umbrella } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const tipIcons = [CloudRain, Shirt, Footprints, Umbrella];

export function Weather() {
  const { t } = useI18n();
  const tips = t.weather.tips.map((tp, i) => ({ ...tp, icon: tipIcons[i] ?? CloudRain }));
  return (
    <section id="weer" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-12 md:grid-cols-12 md:items-end">
          <div className="md:col-span-6">
            <p className="font-mono-cinema text-[10px] text-gold">{t.weather.eyebrow}</p>
            <h2 className="mt-5 font-display text-4xl font-medium leading-[1.05] md:text-5xl">
              {t.weather.title1}
              <span className="block italic text-gold">{t.weather.title2}</span>
            </h2>
          </div>
          <p className="text-foreground/70 md:col-span-6 md:text-lg">
            {t.weather.body}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid-cols-4">
          {tips.map((t) => (
            <div key={t.title} className="bg-card p-6 md:p-7">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold/10 text-gold">
                <t.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 font-display text-base md:text-lg">{t.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground/65">{t.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}